import { SubmitJobPort } from './ports'
import Job from 'jobs/Job'
import JobStore from 'jobs/JobStore'

/**
 * Adapter for SubmitJobDialog.
 */
export default class SubmitJobDialogAdapter implements SubmitJobPort {
  constructor(private jobStore: JobStore) {}

  /**
   * Submits the job.
   */
  async submitRequest(job: Job, bypassBilling: boolean): Promise<void> {
    await this.jobStore.submitRequestV3(job.id, {
      paymentMethod: null,
      bypassBilling,
    })
  }
}
